import { useScreenState } from 'components/Screen';
import { useQueryClient } from 'query';
import { FILTERS, TABLE_SETTINGS } from 'scenes/FinancePage/constants';

import { grid } from './queryKeyFactory';

export const useResetPagination = () => {
  const queryClient = useQueryClient();
  const screenState = useScreenState();

  return async () => {
    await queryClient.setQueryData(
      grid({
        [TABLE_SETTINGS]: screenState[TABLE_SETTINGS],
        [FILTERS]: screenState[FILTERS],
      }),
      (data: any) => {
        const firstPage = data?.pages?.[0];
        const firstPageParams = data?.pageParams?.[0];
        return {
          pages: [...(firstPage ? [firstPage] : [])],
          pageParams: [...(firstPageParams ? [firstPageParams] : [])],
        };
      }
    );
  };
};
